import React, { createContext, useMemo, useState } from 'react';
import PropTypes from 'prop-types';

export const BankContext = createContext();

const BankContextProvider = ({ children }) => {
  const [selectedBank, setSelectedBank] = useState(null);
  const contextValue = useMemo(() => ({ selectedBank, setSelectedBank }), [selectedBank]);
  return (
    <BankContext.Provider value={contextValue}>
      {children}
    </BankContext.Provider>
  );
};

export default BankContextProvider;

BankContextProvider.propTypes = {
  children: PropTypes.node,
};
